module.exports = __webpack_public_path__ + "static/media/infoIcon.6067a44a.svg";